import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { BulletList } from '@blueprint/ui';

export const FeaturesContainer = styled('div')(
    ({ theme }) => css`
        padding-left: ${theme.spacing['8px']};
    `
);

export const FeaturesList = styled(BulletList)(
    ({ theme }) => css`
        ${theme.mq.medium} {
            display: flex;
            flex-wrap: wrap;

            li {
                width: 50%;
                padding-right: ${theme.spacing['16px']};

                &:not(:last-child) {
                    margin-right: 0;
                }
            }
        }
    `
);

export const HighlightedFeaturesList = styled('ul')(({ theme }) => {
    return css`
        margin: 0;
        padding: 0;
        list-style: none;

        ${theme.mq.medium} {
            display: flex;
        }

        li {
            display: flex;
            width: 50%;
            padding-right: ${theme.spacing['16px']};
            margin-bottom: ${theme.spacing['8px']};
            align-items: center;

            ${theme.mq.medium} {
                margin-bottom: 0;
            }

            svg {
                margin-right: ${theme.spacing['4px']};
                fill: ${theme.colors['primary-brand']};
            }
        }

        p {
            display: inline-block;
        }
    `;
});

export const Description = styled('div')(({ theme }) => {
    return css`
        margin-top: ${theme.spacing['16px']};
    `;
});
